import SignInBySoftTokenForm from './SignInBySoftTokenFormContainer';

export default SignInBySoftTokenForm;
